import type { ResourceGlobal } from "@@/shared/acquire/resources/resource-global";
import type { ResourceReservation } from "@@/shared/acquire/resources/resource-reservation";
import { resourceReservationIdZodSchema } from "@@/shared/acquire/resources/resource-reservation-id";
import type { ProviderId } from "@@/shared/providers/provider-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { z } from "zod";
import {
    agendaItem_DropInDataFactory,
    agendaItem_DropInDataZodObject,
} from "./agenda-item-drop-in-data";

const agendaItem_DropInZodObject = z.object({
    _id: resourceReservationIdZodSchema,
    _type: z.literal("AGENDA_ITEM"),
    type: z.literal("DROP_IN"),
    providerId: providerIdZodSchema,
    hasComments: z.boolean().default(false),
    hasWarnings: z.boolean().default(false),

    // Reservations
    reservation: agendaItem_DropInDataZodObject,
});
type AgendaItem_DropIn = z.infer<typeof agendaItem_DropInZodObject>;

const agendaItem_DropInFactory = {
    from: (params: {
        providerId: ProviderId;
        reservation: ResourceReservation & { type: "DROP_IN" };
        resource: ResourceGlobal;
    }): AgendaItem_DropIn => {
        const { providerId, reservation, resource } = params;
        return {
            _id: reservation._id,
            _type: "AGENDA_ITEM",
            type: "DROP_IN",
            providerId,
            hasComments: false,
            hasWarnings: false,
            reservation: agendaItem_DropInDataFactory.from({
                reservation,
                resource,
            }),
        };
    },
};

export { agendaItem_DropInFactory, agendaItem_DropInZodObject };
export type { AgendaItem_DropIn };
